module.exports = "/fonts/gothamblack.woff?84f14561ba6eb92288335b9c7557f391";